import { z } from 'zod';

const AssetDisposalObjectSchema = z.object({
    title: z.string().min(1, 'validation.required.title'),
    kind: z.enum(['decommission', 'destruction', 'transfer', 'recycle']).optional(),
    destructionMethod: z.union([z.string(), z.null()]).optional(),
    plannedDate: z.union([z.string(), z.coerce.date()]).optional(),
    completedAt: z.union([z.string(), z.coerce.date()]).optional(),
    certificateId: z.string().optional(),
    certificateDocumentId: z.string().optional(),
    status: z.enum(['planned', 'inProgress', 'completed', 'certified']).optional(),
    linkedAssets: z.array(z.string()).optional(),
    responsibleUser: z.string().optional(),
    notes: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
}).passthrough();

export const CreateAssetDisposalSchema = AssetDisposalObjectSchema;
export const UpdateAssetDisposalSchema = AssetDisposalObjectSchema.partial();
